import React from "react";
import { Image } from "react-native";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

/**
 * Displays a stored (in Amazon S3 for example) image using the image resizer service.
 *
 * In cases where the imageId is not specified, a placeholder is used instead.
 *
 * Props:
 * imageId: Token id of the image as found in the Amazon S3 bucket, this is used by the image resizer.
 * width, height: Width and height of the image as it will be shown.
 * placeholder: Image that will be used when the imageId is null.
 * bucketIndex: Bucket index configured in the image resizer on the server side.
 * templateIndex: Template index configured in the image resizer on the server side.
 */
const StoredImage = ({ data: { ConnectionInfo: { imageResizerUrl } = {} }, imageId, placeholder, bucketIndex, templateIndex, width, height, style, ...restProps }) => {
  let uri = imageId ? `${imageResizerUrl}/image?name=original&bucketIndex=${bucketIndex}&templateIndex=${templateIndex}&pk=${imageId}&width=${width * 2}&height=${height * 2}` : placeholder,
  // let uri = imageId ? `${imageResizerUrl}/imageresizer/image?name=original&bucketIndex=${bucketIndex}&templateIndex=${templateIndex}&pk=${imageId}&width=${width * 2}&height=${height * 2}` : placeholder,
    source;

  if (typeof uri === "string") {
    // Image was specified as a remote URL, so we specify it that way
    source = { uri };
  } else {
    // This happens when the image (most likely the placeholder) is part of the native binary and the image is represented as a number
    source = uri;
  }

  return (
    <Image
      {...restProps}
      style={{width, height, ...style}}
      source={source}
    />
  );
};

StoredImage.defaultProps = {
  bucketIndex: 0,
  templateIndex: 0
};

export default graphql(gql`query { ConnectionInfo @client { imageResizerUrl } }`)(StoredImage);
